import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import auth from './modules/auth'
import master from './modules/master'
import order from './modules/order'
import partner from './modules/partner'
import role from './modules/role'
import admin from './modules/admin'
import armada from './modules/armada'
import courier from './modules/courier'
import hub from './modules/hub'
import assignment from './modules/assignment'
import merchant from './modules/merchant'
import summary from './modules/summary'
import notifications from './modules/notifications'
import aichat from './modules/aichat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    common,
    master,
    order,
    partner,
    role,
    admin,
    armada,
    courier,
    hub,
    assignment,
    merchant,
    summary,
    notifications,
    aichat
  }
})
